import { UndoOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledButton } from '../ImageViewer.style';

type RotateProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
  title?: string;
};

export const Rotate: React.FunctionComponent<RotateProps> = ({
  onChange,
  value = false,
  disabled = false,
  title,
}) => {
  const { t } = useTranslation();
  const handleClick = useCallback(() => {
    onChange({ rotate: !value });
  }, [value, onChange]);

  return (
    <StyledButton
      data-testid="image-controls-rotate"
      title={title ?? t('components.rotate', 'Rotate')}
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
    >
      <UndoOutlined />
    </StyledButton>
  );
};
